import comp from '../components/barrel';
import U from '../js/utils';
import { downloadClientListReport } from '../js/clientListReport';

export default {
  async prepare() {
    this.vars = this.vars || {};
    this.vars.selected_page = this.vars.selected_page || 1;
    const hdrs = await O.getAuthHdrs();
    this.vars.advisor = hdrs.user_uuid || '';
  },

  async render() {
    await this.fetchAppList();
  },

  async fetchAppList() {
    if (!this.vars.advisor) {
      comp.toast('Unable to load client list — user not identified.');
      return;
    }

    const hdrs = await O.getAuthHdrs();
    const vars = {};
    vars.filters = { advisor: this.vars.advisor };
    vars.limit = 50;
    vars.page = parseInt(String(this.vars.selected_page), 10) || 1;
    vars.user_uuid = hdrs.user_uuid ? hdrs.user_uuid : '';

    try {
      const res = await O.PREP([await O.mPOST('application/app-list', vars)]);
      const listData = res['application/app-list'];
      const appListData = listData.data || [];
      const paginationState = listData.pagination;
      if (paginationState) {
        this.vars.selected_page = paginationState.current_page;
      }
      await this.buildRepTableBody(appListData);
      if (paginationState) {
        await this.buildRepPaginationButtons(paginationState);
        this.updatePaginationInfo(paginationState);
      }
    } catch (e) {
      /* ignore */
    }
  },

  async buildRepTableBody(appListData) {
    const appTableBody = U.id('repAdvisorAppTableBody');
    if (!appTableBody) return;
    appTableBody.innerHTML = '';

    if (appListData.length) {
      for (const row of appListData) {
        const appRow = appTableBody.insertRow();

        const party1_names = appRow.insertCell(0);
        party1_names.innerHTML = row.party1_names;
        party1_names.style.wordWrap = 'break-word';
        party1_names.style.whiteSpace = 'normal';
        party1_names.style.overflowWrap = 'break-word';
        party1_names.style.maxWidth = '200px';

        const party2_names = appRow.insertCell(1);
        party2_names.innerHTML = row.party2_names;
        party2_names.style.wordWrap = 'break-word';
        party2_names.style.whiteSpace = 'normal';
        party2_names.style.overflowWrap = 'break-word';
        party2_names.style.maxWidth = '200px';

        const status = appRow.insertCell(2);
        const tag = await comp.statusTag(row.status);
        status.appendChild(tag);

        const willNumberCell = appRow.insertCell(3);
        const willNum = row.importwillnumber;
        willNumberCell.innerHTML =
          willNum !== undefined && willNum !== null && willNum !== '' ? String(willNum) : '';

        const updatedDateCell = appRow.insertCell(4);
        updatedDateCell.innerHTML = await this.formatAppListDate(row.updated_date ?? row.updatedDate);

        const reviewedWithClientCell = appRow.insertCell(5);
        reviewedWithClientCell.innerHTML = await this.formatAppListDate(
          row.reviewed_with_client ?? row.reviewedWithClient
        );

        const icons = appRow.insertCell(6);
        icons.style.width = '40px';
        icons.style.minWidth = '40px';
        icons.style.maxWidth = '40px';
        icons.style.textAlign = 'center';
        icons.style.padding = '4px';

        const iconsContainer = document.createElement('div');
        iconsContainer.style.display = 'flex';
        iconsContainer.style.gap = '4px';
        iconsContainer.style.justifyContent = 'center';
        iconsContainer.style.alignItems = 'center';

        if (row.final_discount_yn === true || row.final_discount_yn === 'true' || row.final_discount_yn === 1) {
          const dCircle = document.createElement('div');
          dCircle.style.width = '20px';
          dCircle.style.height = '20px';
          dCircle.style.borderRadius = '50%';
          dCircle.style.backgroundColor = '#3b82f6';
          dCircle.style.color = 'white';
          dCircle.style.display = 'flex';
          dCircle.style.alignItems = 'center';
          dCircle.style.justifyContent = 'center';
          dCircle.style.fontSize = '12px';
          dCircle.style.fontWeight = 'bold';
          dCircle.style.cursor = 'help';
          dCircle.textContent = 'D';
          dCircle.title = 'Discount recorded';
          iconsContainer.appendChild(dCircle);
        }

        if (row.has_products_yn === true || row.has_products_yn === 'true' || row.has_products_yn === 1) {
          const pCircle = document.createElement('div');
          pCircle.style.width = '20px';
          pCircle.style.height = '20px';
          pCircle.style.borderRadius = '50%';
          pCircle.style.backgroundColor = '#3b82f6';
          pCircle.style.color = 'white';
          pCircle.style.display = 'flex';
          pCircle.style.alignItems = 'center';
          pCircle.style.justifyContent = 'center';
          pCircle.style.fontSize = '12px';
          pCircle.style.fontWeight = 'bold';
          pCircle.style.cursor = 'help';
          pCircle.textContent = 'P';
          pCircle.title = 'Products linked';
          iconsContainer.appendChild(pCircle);
        }

        icons.appendChild(iconsContainer);

        const created_date = appRow.insertCell(7);
        created_date.innerHTML = await U.formatDate(row.created_date);

        const signedDateCell = appRow.insertCell(8);
        signedDateCell.innerHTML = await this.formatAppListDate(
          row.importsigneddate ?? row.importSignedDate
        );

        const receivedDateCell = appRow.insertCell(9);
        receivedDateCell.innerHTML = await this.formatAppListDate(
          row.importrecbackdate ?? row.importRecBackDate
        );

        const will_type = appRow.insertCell(10);
        will_type.innerHTML = row.app_type;
      }
    } else {
      const appRow = appTableBody.insertRow();
      const empty = appRow.insertCell(0);
      empty.innerHTML = 'No applications available.';
      empty.colSpan = 11;
    }
  },

  async formatAppListDate(value) {
    if (value == null || value === '') {
      return '';
    }
    const str = String(value).trim();
    const isoMatch = str.match(/^(\d{4}-\d{2}-\d{2})/);
    if (isoMatch) {
      return await U.formatDate(isoMatch[1]);
    }
    return await U.formatDate(str);
  },

  async buildRepPaginationButtons(paginationState) {
    const wrapper = U.id('repAdvisorPaginationWrapper');
    if (!wrapper) return;
    await comp.paginationButtons({ totalPages: paginationState.total_pages, wrapperID: 'repAdvisorPaginationWrapper' });
    const pageButtons = wrapper.querySelectorAll('.pageButton');
    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
        this.fetchAppList();
      });
    });
  },

  updatePaginationInfo(paginationState) {
    const totalRecordsTop = U.id('repAdvisorTotalRecordsDisplay');
    const totalPagesTop = U.id('repAdvisorTotalPagesDisplay');
    if (totalRecordsTop) {
      totalRecordsTop.textContent = paginationState.total_records != null ? paginationState.total_records : '-';
    }
    if (totalPagesTop) {
      totalPagesTop.textContent = paginationState.total_pages != null ? paginationState.total_pages : '-';
    }
    const totalRecordsBottom = U.id('repAdvisorTotalRecordsDisplayBottom');
    const totalPagesBottom = U.id('repAdvisorTotalPagesDisplayBottom');
    if (totalRecordsBottom) {
      totalRecordsBottom.textContent = paginationState.total_records != null ? paginationState.total_records : '-';
    }
    if (totalPagesBottom) {
      totalPagesBottom.textContent = paginationState.total_pages != null ? paginationState.total_pages : '-';
    }
  },

  /**
   * Export via reports/client-list — body: advisor_uuid, user_uuid.
   */
  async exportRepAdvisor() {
    await downloadClientListReport(this.vars.advisor);
  },
};
